import '@theme/product-form';
import '@theme/fly-to-cart';
import { StandardEvents } from '@shopify/events';

// Keep package purchases on the pricing page and use the theme's cart drawer.
class PricingCart extends HTMLElement {
  connectedCallback() {
    this.addEventListener(StandardEvents.cartLinesUpdate, this.openCart);
  }

  disconnectedCallback() {
    this.removeEventListener(StandardEvents.cartLinesUpdate, this.openCart);
  }

  openCart = async (event) => {
    if (event.action !== 'add' || !event.promise) return;

    const flights = Array.from(document.querySelectorAll('fly-to-cart'))
      .filter((flight) => this.contains(flight.source))
      .flatMap((flight) => {
        // Match the product-card + button; the main product curve swings far backward.
        flight.classList.replace('fly-to-cart--main', 'fly-to-cart--quick');
        return flight.getAnimations().map((animation) => animation.finished);
      });

    try {
      const { detail } = await event.promise;
      if (detail?.didError) return;
      await Promise.allSettled(flights);
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) {
        window.location.assign(Theme.routes.cart_url);
        return;
      }
      await customElements.whenDefined('theme-drawer');
      if (this.isConnected && !drawer.isOpen) drawer.open();
    } catch {
      // The product form and cart components handle unsuccessful cart updates.
    }
  };
}

if (!customElements.get('cr-pricing-cart')) {
  customElements.define('cr-pricing-cart', PricingCart);
}
